<template>
  <div class="content">
    <div class="page-inner">
      <section class="scrollable">
        <div class="bg-light">
          <h3 class="font-thin my-0" v-if="playlist">{{ playlist.name }}</h3>
        </div>
        <section class="mt-2">
          <p v-if="!loading && !requests.length">
            {{ $t('no_requests_yet') }}
          </p>
          <div class="card my-1" v-for="(item) in requests" v-bind:key="item._id">
            <div class="card-body">
              <div class="float-left thumb-md mr-2">
                <a :href="'https://indiefy.me/' + item.artist.key" target="_blank">
                  <img :src="item.artist.cover_image_small || item.artist.cover_image" v-bind:alt="item.image" class="img-thumbnail" onerror="this.src = 'https://indiefy.net/img/img-placeholder.jpg'">
                </a>
              </div>
              <div class="float-right d-none d-sm-block">
                <a :href="item.url" class="btn btn-default btn-sm" target="_blank" >
                  <i class="fa fa-music mr-1"></i><span> {{ $t('open_link') }}</span>
                </a>
                <button type="button" class="btn btn-sm btn-success" @click="approveRequest(item)" v-if="item.status == 0">
                  {{ $t('approve_request') }}
                </button>
                <button type="button" class="btn btn-sm btn-danger" @click="rejectRequest(item)" v-if="item.status == 0">
                  {{ $t('reject_request') }}
                </button>
              </div>
              <div>
                <div>
                  <a :href="'https://indiefy.me/' + item.artist.key" target="_blank">{{ item.artist.name }}</a>
                </div>
                <div class="m-b-xs">
                  <small><b>{{ $t('genre') }}:</b> {{ item.main_genre }}</small>
                </div>
                <div>
                  <span class="badge badge-default" v-if="item.status == 0">
                    {{ $t('in_review') }}
                  </span>
                  <span class="badge badge-primary" v-if="item.status == 1">
                    {{ $t('approved') }}
                  </span>
                  <span class="badge badge-danger" v-if="item.status == 2">
                    {{ $t('rejected') }}
                  </span>
                </div>
                <div class="d-block d-sm-none mt-2">
                  <a :href="item.url" class="btn btn-default btn-sm mr-1" target="_blank">
                    <i class="fa fa-music"></i>
                  </a>
                  <button type="button" class="btn btn-sm btn-success mr-1" @click="approveRequest(item)" v-if="item.status == 0">
                    <i class="fa fa-check"></i>
                  </button>
                  <button type="button" class="btn btn-sm btn-danger" @click="rejectRequest(item)" v-if="item.status == 0">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div class="modal fade" data-backdrop="static" tabindex="-1" role="dialog" id="modal-approve">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title font-bold">
                  {{ $t('approve_request') }}
                </h4>
              </div>
              <div class="modal-body">
                <p class="h4">
                  {{ $t('before_approving') }}
                </p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">{{ $t('cancel') }}</button>
                <button type="button" class="btn btn-success" @click="confirmApproval()">
                  {{ $t('song_added') }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" data-backdrop="static" tabindex="-1" role="dialog" id="modal-reject">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title font-bold">
                  {{ $t('reject_request') }}
                </h4>
              </div>
              <div class="modal-body">
                <div class="h4">
                  {{ $t('provide_feedback') }}
                </div>
                <div class="mt-2">
                  <textarea v-model="feedback" class="form-control" rows="4"></textarea>
                  <div class="alert alert-warning mt-2" v-if="feedback && feedback.length <= 30">
                    {{ $t('feedback_too_short') }}
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">{{ $t('cancel') }}</button>
                <button type="button" class="btn btn-danger" @click="confirmRejection()">
                  {{ $t('reject_request') }}
                </button>
              </div>
            </div>
          </div>
        </div>

      </section>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      approving: {},
      removing: {},
      loading: true,
      playlist: {
        name: ''
      },
      requests: [],
      feedback: ''
    }
  },
  methods: {
    getPlaylistData: function (playlist) {
      let playlistId = playlist.url || ''

      try {
        if (playlistId.match(/\//)) {
          playlistId = playlistId.split('/playlist/')[1]
        }

        if (playlistId && playlistId.match(/\//)) {
          playlistId = playlistId.split('/')[0]
        }

        if (playlistId.match(/\?/)) {
          playlistId = playlistId.split('?')[0]
        }
      } catch (e) {
        console.error('Error when getting playlist id', playlist)
      }

      $.ajax({
        url: `https://api.spotify.com/v1/playlists/${playlistId}`,
        headers: {
          'Authorization': 'Bearer ' + this.accessToken
        },
        method: 'GET',
        success: (data) => {
          this.playlist.name = data.name
        }
      })
    },
    getRequests: function () {
      this.$http.get(`${window.apiURL}api/playlist-request/${this.$route.params.id}`, { withCredentials: true }).then(response => {
        this.requests = response.data
        this.loading = false
      })
    },
    approveRequest: function (item) {
      this.approving = item
      $('#modal-approve').modal('show')
    },
    rejectRequest: function (item) {
      $('#modal-reject').modal('show')
      this.removing = item
    },
    confirmApproval: function () {
      $('#modal-approve').modal('hide')
      this.$http.put(`${window.apiURL}api/playlist-request/${this.approving._id}`, { status: 1 }, { withCredentials: true }).then(response => {
        this.approving = null
        this.getRequests()
      })
    },
    confirmRejection: function () {
      $('#modal-reject').modal('hide')

      if (!this.feedback) {
        this.$notify({ message: this.$t('please_add_feedback') }, 'warning', 'fa-exclamation')

        return setTimeout(() => {
          $('#modal-reject').modal('show')
        }, 3000)
      }

      if (this.feedback.length <= 30) {
        this.$notify({ message: this.$t('feedback_too_short') }, 'warning', 'fa-exclamation')

        return setTimeout(() => {
          $('#modal-reject').modal('show')
        }, 3000)
      }

      this.$http.post(`${window.apiURL}api/reject-request/${this.removing._id}`, { feedback: this.feedback, status: 2 }, { withCredentials: true }).then(response => {
        this.removing = null
        this.feedback = ''
        this.getRequests()
      })
    }
  },
  created () {
    this.accessToken = this.$spotify.token

    this.$http.get(`${window.apiURL}api/playlists/${this.$route.params.id}`, { withCredentials: true }).then(response => {
      response.data.name = ''
      this.getPlaylistData(response.data)
    })

    this.getRequests()
  }
}
</script>
<style scoped>
  .thumb-md {
    width: 65px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MyPlaylistRequests.vue